var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('span',{staticClass:"col-md-2"},[_c('label',{attrs:{"for":_vm.inputId}},[_vm._v(" "+_vm._s(_vm.label || _vm.name)+" ")])]),_c('div',{staticClass:"col-12 large-checklist-confirmation-display",attrs:{"id":_vm.inputId,"name":_vm.label}},[_vm._v(_vm._s(_vm.value)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }